import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { api, getTicketTypeNumberOfAvailableTickets } from "ticketino-api-client";

import Header from './../components/Header'
import Description from './../components/DescriptionDayOfOpenDoors'
import Footer from "./../components/Footer";
import Loading from "./../components/Loading";

const Step10_Ticket = () => {
    const [eventId, setEventId] = useState(0);
    const [posId, setPosId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resources, setResources] = useState({});
    const [orderId, setOrderId] = useState("");
    const [token, setToken] = useState(sessionStorage.getItem("token"));
    const [errors, setErrors] = useState("");
    const [selectedTicketTypeId, setSelectedTicketTypeId] = useState(null);
    const [quantity, setQuantity] = useState(0);
    const [availableTickets, setAvailableTickets] = useState(null);
    const [beginTime] = useState(sessionStorage.getItem("BeginTime"));
    const [endTime] = useState(sessionStorage.getItem("EndTime"));
    const slotAvailableTickets = parseInt(sessionStorage.getItem("SlotAvailableTickets"), 10);

    const navigate = useNavigate();
    const location = useLocation();
    const baseUrl = process.env.REACT_APP_BASEURL_API;
    const language = "de"; // Default language

    api.defaults.baseURL = baseUrl;

    const contentRef = useRef(null);

    useEffect(() => {
        if (resources && Object.keys(resources).length > 0) {
            if (contentRef.current) {
                window.scrollTo({ top: contentRef.current.offsetTop - 50 });
            }
        }
    }, [resources]);

    useEffect(() => {
        if (token) {
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            api.defaults.headers.common["Authorization"] = "Bearer " + token;
        }
        requestResources();
        requestFormSettings();
    }, []);

    useEffect(() => {
        if (selectedTicketTypeId && orderId) {
            getTicketTypeNumberOfAvailableTickets(selectedTicketTypeId, orderId)
                .then((availability) => {
                    const ticketTypeMax = availability?.availableTickets ?? null;
                    // Cap at the tighter of the two limits: ticket type capacity and time slot remaining seats.
                    // e.g. ticket type allows 5 but slot has 1 left → max is 1; slot has 10 → max stays 5.
                    if (ticketTypeMax === null) {
                        setAvailableTickets(!isNaN(slotAvailableTickets) ? slotAvailableTickets : null);
                    } else {
                        setAvailableTickets(!isNaN(slotAvailableTickets) ? Math.min(ticketTypeMax, slotAvailableTickets) : ticketTypeMax);
                    }
                })
                .catch(console.error);
        }
    }, [selectedTicketTypeId, orderId]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/de`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // Use Day of Open Doors ticket type IDs
            setEventId(res.data.eventId_DayOfOpenDoors);
            setSelectedTicketTypeId(res.data.registerTicketTypeId_DayOfOpenDoors);
            setPosId(res.data.posId);
            startOrder(res.data.posId);
        });
    };

    const startOrder = (posId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
            deliveryType: 1,
        };

        axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
            })
            .catch((error) => console.error(error.response.data));
    };

    const addTicketToBasket = async () => {
        let addTicketTypes = [];

        if (!beginTime && !endTime) {
            navigate(`/${language}/day-of-open-doors`);
        }

        addTicketTypes.push({
            ticketTypeId: parseInt(selectedTicketTypeId),
            quantity: quantity,
            timOfEntryFrom: beginTime,
            timOfEntryTo: endTime,
        });

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                navigate(`/${language}/day-of-open-doors/participant`);
            })
            .catch((error) => {
                console.error(error.response.data);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
            });
    };

    const handleSubmit = async () => {
        // Prevent double submission
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        try {
            // Store ticket type ID for confirmation page
            sessionStorage.setItem("SelectedTicketTypeId", selectedTicketTypeId);

            await addTicketToBasket();
        } catch (error) {
            console.error("Error during submission:", error);
            setErrors(resources?.ErrorOccurred || "An error occurred");
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <Header resources={resources} title={resources?.DayOfOpenDoor_HomeTitle} />
            {loading ? (
                <Loading
                    alignment="center"
                    color="#d3d3d3"
                    bgColor="#fff"
                    top="50%"
                />
            ) : (
                <>
                    <div className="container page-container">

                        <div className="mt-4 page-container-smaller">

                            <Description resources={resources} />

                            {errors !== "" && (
                                <div className="alert alert-danger" role="alert">
                                    {errors}
                                </div>
                            )}

                            <div ref={contentRef} className="mt-5 mb-5 buyer-information-box" style={{ paddingBottom: "90px" }}>

                                <span className="subtitle mt-4 mb-5">Wählen Sie hier die Anzahl zu buchender Tickets:</span>

                                <div className="ticket-quantity-box mt-5">
                                    <div className="row text-center">
                                        <div className="col-12">
                                            <span><b>Sonntag,</b></span><br />
                                            <span><b>20. September 2026</b></span>
                                        </div>
                                    </div>

                                    <div className="row mt-4 justify-content-center">
                                        <div className="col-auto">
                                            <div className="quantity-stepper">
                                                <button
                                                    className="quantity-btn"
                                                    onClick={() => setQuantity(q => Math.max(0, q - 1))}
                                                    disabled={quantity === 0}
                                                >-</button>
                                                <span className="quantity-value">{quantity}</span>
                                                <button
                                                    className="quantity-btn"
                                                    onClick={() => setQuantity(q => availableTickets !== null ? Math.min(availableTickets, q + 1) : q + 1)}
                                                    disabled={availableTickets !== null && quantity >= availableTickets}
                                                >+</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-4 justify-content-center">
                                        <div className="col-auto">
                                            <button
                                                className="btn btn-custom btn-next"
                                                onClick={handleSubmit}
                                                disabled={isSubmitting || quantity === 0}
                                            >
                                                {resources?._Next}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </div>
    )
}

export default Step10_Ticket
